// extracted by mini-css-extract-plugin
export default {"profilesArea":"Profiles_profilesArea__Z+pd3","writerCount":"Profiles_writerCount__iK9Fk","small":"Profiles_small__u4Bcj","xSmall":"Profiles_xSmall__tLQEz"};